import React, { useState } from 'react';
import config from '../../config';
import './MediaCard.css';

function MediaCard({ media, onSelect, onDelete, onUpdate, isSelected = false }) {
    const [showActions, setShowActions] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [editedAltText, setEditedAltText] = useState(media.alt_text || '');
    const [editedCategory, setEditedCategory] = useState(media.category || 'other');

    const handleDelete = (e) => {
        e.stopPropagation();
        if (window.confirm(`Supprimer "${media.filename}" ?`)) {
            onDelete(media.id);
        }
    };

    const handleEdit = (e) => {
        e.stopPropagation();
        setIsEditing(true);
    };

    const handleSave = async (e) => {
        e.stopPropagation();
        if (onUpdate) {
            await onUpdate(media.id, {
                alt_text: editedAltText,
                category: editedCategory
            });
        }
        setIsEditing(false);
    };

    const handleCancel = (e) => {
        e.stopPropagation();
        setEditedAltText(media.alt_text || '');
        setEditedCategory(media.category || 'other');
        setIsEditing(false);
    };

    const formatFileSize = (bytes) => {
        if (bytes < 1024) return bytes + ' B';
        if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
        return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
    };

    const getCategoryLabel = (category) => {
        const labels = {
            logo: 'Logo',
            photo: 'Photo',
            icon: 'Icône',
            banner: 'Bannière',
            other: 'Autre'
        };
        return labels[category] || category;
    };

    const getCategoryColor = (category) => {
        const colors = {
            logo: '#3b82f6',
            photo: '#10b981',
            icon: '#f59e0b',
            banner: '#8b5cf6',
            other: '#6b7280'
        };
        return colors[category] || '#6b7280';
    };

    return (
        <div
            className={`media-card ${isSelected ? 'selected' : ''}`}
            onClick={() => onSelect(media)}
            onMouseEnter={() => setShowActions(true)}
            onMouseLeave={() => setShowActions(false)}
        >
            {/* Image preview */}
            <div className="media-preview">
                <img
                    src={config.getUploadUrl(media.file_path)}
                    alt={media.alt_text || media.filename}
                    loading="lazy"
                />

                {/* Badge catégorie */}
                <div
                    className="media-category-badge"
                    style={{ backgroundColor: getCategoryColor(media.category) }}
                >
                    {getCategoryLabel(media.category)}
                </div>

                {/* Actions overlay */}
                {showActions && !isEditing && (
                    <div className="media-actions-overlay">
                        <button
                            className="media-action-btn edit"
                            onClick={handleEdit}
                            title="Éditer"
                        >
                            ✏️
                        </button>
                        <button
                            className="media-action-btn delete"
                            onClick={handleDelete}
                            title="Supprimer"
                        >
                            🗑️
                        </button>
                    </div>
                )}

                {/* Sélection checkbox */}
                {isSelected && (
                    <div className="media-selected-indicator">
                        ✓
                    </div>
                )}
            </div>

            {/* Infos */}
            <div className="media-info">
                {!isEditing ? (
                    <>
                        <div className="media-filename" title={media.filename}>
                            {media.filename}
                        </div>
                        {media.alt_text && (
                            <div className="media-alt-text" title={media.alt_text}>
                                Alt: {media.alt_text}
                            </div>
                        )}
                        <div className="media-meta">
                            {media.width && media.height && (
                                <span className="media-dimensions">
                                    {media.width} × {media.height}
                                </span>
                            )}
                            <span className="media-size">
                                {formatFileSize(media.file_size)}
                            </span>
                        </div>
                    </>
                ) : (
                    <div className="media-edit-form" onClick={(e) => e.stopPropagation()}>
                        <div className="edit-field">
                            <label>Catégorie</label>
                            <select value={editedCategory} onChange={(e) => setEditedCategory(e.target.value)}>
                                <option value="logo">Logo</option>
                                <option value="photo">Photo</option>
                                <option value="icon">Icône</option>
                                <option value="banner">Bannière</option>
                                <option value="other">Autre</option>
                            </select>
                        </div>
                        <div className="edit-field">
                            <label>Texte alternatif</label>
                            <input
                                type="text"
                                value={editedAltText}
                                onChange={(e) => setEditedAltText(e.target.value)}
                                placeholder="Description de l'image"
                            />
                        </div>
                        <div className="edit-actions">
                            <button className="btn-save" onClick={handleSave}>✓</button>
                            <button className="btn-cancel" onClick={handleCancel}>✕</button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}

export default MediaCard;
